import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
  icon?: React.ReactNode;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#planes',
  className = '',
  icon
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-xl text-center font-display font-bold uppercase tracking-[0.02em] transition-[transform,box-shadow,background-color,color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-400/50 active:translate-y-px';
  const sizes = {
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-8 py-4 text-base md:text-lg',
    xl: 'px-8 py-5 text-lg md:text-xl'
  };
  const variants = {
    primary: 'bg-gradient-to-r from-indigo-500 to-violet-500 text-white shadow-glow hover:from-indigo-600 hover:to-violet-600',
    secondary: 'bg-night-700 text-gold-300 ring-1 ring-inset ring-gold-400/40 hover:bg-night-600'
  };
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'El Código de Autoridad',
        value: 14990,
        currency: 'ARS'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-44" data-mp="3oviia03qxsey">
      {icon}
      <span data-id="element-45" data-mp="1j7qeu1872bc">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1" aria-hidden="true" data-id="element-46" data-mp="1jzbhax75hnd" />
    </a>;
}